export var SuggestionType;
(function (SuggestionType) {
    SuggestionType["SEARCH"] = "SEARCH";
    SuggestionType["CATEGORY"] = "CATEGORY";
    SuggestionType["APP"] = "APP";
    SuggestionType["NONE_TYPE"] = "NONE_TYPE";
})(SuggestionType || (SuggestionType = {}));
export var AppMarketPage;
(function (AppMarketPage) {
    AppMarketPage["MANAGE_APPS"] = "manage-apps";
    AppMarketPage["APP_PAGE"] = "app_page";
    AppMarketPage["CATEGORY"] = "category";
    AppMarketPage["COLLECTION"] = "collection";
    AppMarketPage["HOMEPAGE"] = "homepage";
    AppMarketPage["SEARCH_RESULT"] = "search-result";
})(AppMarketPage || (AppMarketPage = {}));
//# sourceMappingURL=marketplace.js.map